export const ZIN_KEY_STORY_CITY_PAGE = "cff3030f-d87f-4bf1-847c-536e71685d5f";
export const ZIN_DISPLAY_KEY_STORY_CITY_PAGE = "st_gf22025610td917523";

export const ZIN_KEY_REELS_HOTEL_PAGE = "cff3030f-d87f-4bf1-847c-536e71685d5f";
export const ZIN_DISPLAY_KEY_REELS_HOTEL_PAGE = "st_fn520251010pwz165741";
